import { useParams } from "react-router-dom";
import { Button, Col, Form, FormFeedback, FormGroup, Input, Label, Modal, ModalBody, ModalFooter, ModalHeader, Pagination, PaginationItem, PaginationLink, Spinner } from "reactstrap";
import { MainContainer } from "../Components/MainContainer";
import { SearchBarComponent } from "../Components/SearchBarComponent";
import { useEffect, useState } from "react";
import { Api } from "../Services/CohortServices";
import { TCohortReceive } from "../Types/CohortReceiveType";
import { FormatDate } from "../Utils/FormatDate";
import { FormatCurrency } from "../Utils/FormatCurrency";
import DatePicker, { registerLocale } from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import { ptBR } from "date-fns/locale";
import { NormalizarNome } from "../Utils/NormalizeName";
import { ToasterAdviser } from "../Components/ToasterComponent";
registerLocale("pt-BR", ptBR);

export const CohortById = () => {
  const { id } = useParams<{ id: string }>();
  const [loading, setLoading] = useState(false);
  const [buttonLoading, setButtonLoading] = useState(false);
  const [webhookSalvo, setWebhookSalvo] = useState(false);
  // const [queueComsumed, setQueueConsumed] = useState(false);
  const [deleting, setDeleting] = useState(false);
  const [success, setSuccess] = useState<string | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [errorPage, setErrorPage] = useState<string | null>(null);
  const [cohort, setCohort] = useState<TCohortReceive | null>(null);
  const [filteredClient, setFilteredClient] = useState<TCohortReceive[]>([]);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 30;
  const pagesPerBlock = 5;
  const [modalOpen, setModalOpen] = useState(false);
  const [webhookData, setWebhookData] = useState({
    nome: '',
    query: '',
    tipoExecucao: 'manual',
    parametro: '',
    fila: '',
    dataRange: '',
  });
  const [nomeError, setNomeError] = useState('');
  const [queryError, setQueryError] = useState('');
  const [tipoExecucaoError, setTipoExecucaoError] = useState('');
  const [parametroError, setParametroError] = useState('');
  const [filaError, setFilaError] = useState('');

  // Função para validar o formulário
  const validateForm = () => {
    let valid = true;

    if (!webhookData.nome || webhookData.nome.trim() === '') {
      setNomeError('Por favor, insira o nome.');
      valid = false;
    } else {
      setNomeError('');
    }

    if (!webhookData.query || webhookData.query.trim() === '') {
      setQueryError('A query não pode estar vazia.');
      valid = false;
    } else {
      setQueryError('');
    }

    if (!webhookData.tipoExecucao || webhookData.tipoExecucao.trim() === '') {
      setTipoExecucaoError('Selecione um tipo de execução.');
      valid = false;
    } else {
      setTipoExecucaoError('');
    }

    if (!webhookData.parametro || webhookData.parametro.trim() === '') {
      setParametroError('Por favor, insira o parâmetro.');
      valid = false;
    } else {
      setParametroError('');
    }

    if (!webhookData.fila || webhookData.fila.trim() === '') {
      setFilaError('Por favor, insira a fila.');
      valid = false;
    } else if (!/^[a-zA-Z0-9]+$/.test(webhookData.fila)) {
      setFilaError('A fila deve conter apenas letras e números.');
      valid = false;
    } else {
      setFilaError('');
    }

    return valid;
  };

  const fetchCohortById = async () => {
    setLoading(true);
    try {
      const response = await Api.get(`/clientsByCohort/${id}`);
      if (response.data.message) {
        setErrorPage("Ainda nao foram encontrados Cliente associados ao cohort, tente novamente mais tarde");
      }
      else {
        setCohort(response.data)
      }
    } catch (error) {
      setError("Erro ao buscar os dados, tente novamente mais tarde.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const abortController = new AbortController();
    if (filteredClient.length === 0) {
      fetchCohortById();
    }
    return () => {
      abortController.abort();
    };
    //eslint-disable-next-line
  }, [id]);


  //verifica se ja existe um webhook cadastrado para o cohort
  const checkWebhook = async () => {
    let query = '';
    try {
      try {
        const findQuery = await Api.get(`/cohort-query/${cohort?.cohortTag}`);
        if (findQuery.status === 200) {
          query = findQuery.data.cohort.clients_query ?? '';
        }
      } catch (queryError) {
        query = '';
      }
      const response = await Api.get(`/webhook/${cohort?.cohortTag}`);
      if (response.status === 200) {

        setWebhookData({
          ...webhookData,
          nome: response.data.nome,
          query: query,
          tipoExecucao: response.data.tipo_execucao,
          fila: response.data.fila,
          parametro: response.data.parametro,
          dataRange: response.data.range_time,
        });
        setWebhookSalvo(true);
        // await checkQueue(response.data.fila);
      }
    } catch (error) {
      if (error instanceof Error && (error as any)?.response?.status === 404) {
        setWebhookData({
          ...webhookData,
          nome: '',
          query: query,
          tipoExecucao: 'manual',
          parametro: '',
          fila: '',
          dataRange: '',
        });
      }
    }
  };

  //verifica se a fila foi consumida
  // const checkQueue = async (fila: string) => {
  //   try {
  //     const response = await Api.get(`/queue/empty/${fila}`);
  //     if (response.status === 200) {
  //       setQueueConsumed(true);
  //     } else {
  //       setQueueConsumed(false);
  //     }
  //   } catch (error) {
  //     setQueueConsumed(false);
  //   }
  // };

  useEffect(() => {
    let abortController = new AbortController();
    if (cohort) {
      checkWebhook();
    }
    return () => {
      abortController.abort();
    };
    //eslint-disable-next-line
  }, [cohort]);

  //logica para salvar webhook
  const handleSaveWebhook = async () => {
    // Validação do formulário
    if (!validateForm()) {
      return;
    }
    const dadosParaSalvar = {
      ...webhookData,
      tag: cohort?.cohortTag,
      tipoExecucao: webhookData.tipoExecucao,
    }

    const hookdata = {
      tag: cohort?.cohortTag,
      cpf: cohort?.clients?.map((client) => client.CPF),
      parametro: webhookData.parametro,
      fila: webhookData.fila,
      dateSchedule: webhookData.dataRange,
    };

    try {
      setButtonLoading(true);
      let saveWebhook = await Api.post(`/webhook`, dadosParaSalvar);

      if (saveWebhook.status === 201) {
        if (webhookData.tipoExecucao === 'manual') {
          // apenas salva, backend cuida de enfileirar e executar
          setWebhookSalvo(true);
          setSuccess("Webhook salvo com sucesso. Agora você pode enviar ou consumir da fila.");
          setTimeout(() => {
            setSuccess(null);
            setError(null);
          }, 3000);
        } else if (webhookData.tipoExecucao === 'automatico') {
          let saveAutomatic = await Api.post(`/webhook/automatic`, hookdata)
          if (saveAutomatic.status === 200) {
            setSuccess("Execução automática configurada finalizada com sucesso.");
            setWebhookSalvo(true);
            setModalOpen(false);
            setTimeout(() => {
              setSuccess(null);
              setError(null);
            }, 3000);
          } else {
            setError("Erro ao salvar o webhook automático.");
            setTimeout(() => {
              setSuccess(null);
              setError(null);
            }, 3000);
          }
        } else if (webhookData.tipoExecucao === 'agendado') {
          let saveSchedule = await Api.post(`/webhook/schedule`, hookdata)
          if (saveSchedule.status === 200) {
            setSuccess("Execução agendada configurada finalizada com sucesso.");
            setWebhookSalvo(true);
            setModalOpen(false);
            setTimeout(() => {
              setSuccess(null);
              setError(null);
            }, 3000);
          } else {
            setError("Erro ao salvar o webhook agendado.");
            setTimeout(() => {
              setSuccess(null);
              setError(null);
            }, 3000);
          }
        }
      } else {
        setError("Erro ao salvar o webhook.");
        setTimeout(() => {
          setSuccess(null);
          setError(null);
        }, 3000);
      }
    } catch (error) {
      if (error instanceof Error && (error as any)?.response?.status === 400) {
        setError("Erro ao salvar o webhook. Verifique os dados e tente novamente.");
      } else {
        setError("Erro ao salvar o webhook. Tente novamente mais tarde.");
      }
      setTimeout(() => {
        setSuccess(null);
        setError(null);
      }, 3000);
    } finally {
      setButtonLoading(false);
    }
  };

  const handleReenviarWebhook = async () => {
    try {
      setButtonLoading(true);
      const hookdata = {
        tag: cohort?.cohortTag,
        cpf: cohort?.clients?.map((client) => client.CPF),
        parametro: webhookData.parametro,
        fila: webhookData.fila,
        dateSchedule: webhookData?.dataRange,
      };

      const res = await Api.post(`/webhook/sendQueue`, hookdata);
      if (res.status === 200) {
        setSuccess("Webhook reenviado com sucesso!");
        setTimeout(() => {
          setSuccess(null);
          setError(null);
        }, 3000);
      } else {
        setError("Erro ao reenviar webhook. Tente novamente mais tarde.");
        setTimeout(() => {
          setSuccess(null);
          setError(null);
        }, 3000);
      }
    } catch (error) {
      if (error instanceof Error && (error as any)?.response?.status === 400) {
        setError("Erro ao reenviar webhook. Verifique os dados e tente novamente.");
      } else {
        setError("Erro ao reenviar webhook. Tente novamente mais tarde.");
      }
      setTimeout(() => {
        setSuccess(null);
        setError(null);
      }, 3000);
    }
    finally {
      setButtonLoading(false);
    }
  };

  // Lógica para deletar o webhook
  const handleDelete = async () => {
    if (!window.confirm("Deseja realmente excluir esse Webhook?")) return;
    try {
      setDeleting(true);
      const res = await Api.delete(`/webhook/${cohort?.cohortTag}`);
      if (res.status === 204) {
        alert("Webhook excluído com sucesso!");
        setModalOpen(false);
        setWebhookSalvo(false);
        setWebhookData({
          nome: '',
          query: '',
          tipoExecucao: 'manual',
          parametro: '',
          fila: '',
          dataRange: '',
        });
      }
    } catch (error) {
      alert("Erro ao excluir o webhook.");
    } finally {
      setDeleting(false);
    }
  };

  // Se houver erro, exibe a mensagem e para a renderização
  if (errorPage) {
    return (
      <MainContainer>
        <p style={{ color: "red" }}>{errorPage}</p>
      </MainContainer>
    );
  }

  if (!cohort) {
    return (
      <MainContainer>
        <p>Carregando informações do cohort.</p>
      </MainContainer>
    );
  }

  const clients = filteredClient?.[0]?.clients ?? cohort.clients ?? [];

  const totalPages = Math.ceil(clients.length / itemsPerPage);

  const currentClients = clients.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  // Lógica para calcular o bloco de páginas atual
  const currentBlock = Math.ceil(currentPage / pagesPerBlock);
  const startPage = (currentBlock - 1) * pagesPerBlock + 1;
  const endPage = Math.min(startPage + pagesPerBlock - 1, totalPages);

  const handlePageChange = (page: number) => {
    setCurrentPage(page);
  };

  return (
    <MainContainer>
      <>
        <div className="main-content">
          <div className="mt-1">
            <Col md={12}>
              <div style={{ fontSize: '2.25rem ', fontWeight: '900 ', color: '#000' }}>
                Detalhes do Cohort: {cohort.cohortTag}
              </div>
              <SearchBarComponent<TCohortReceive>
                searchPlaceholder="Pesquisar por CPF ou Nome"
                buttonName="Criar Cohort"
                buttonRoute="/createcohort"
                setFilteredClient={setFilteredClient}
                isLoading={setLoading}
              />

              {loading ? (
                <p className="d-flex align-items-center mt-4">Carregando...</p>
              ) : currentClients?.length !== 0 ? (
                <div className="clients_list_container">
                  <div>
                    <Button onClick={() => setModalOpen(true)} className="mt-2 cohort_search_button">
                      Adicionar Fila
                    </Button>
                    {currentClients?.map((client, index) => (
                      <div className="clients_list mt-2" key={index} style={{
                      }}>
                        <Col md={2}>
                          <strong >CPF:</strong>
                          <div>{client.CPF}</div>
                        </Col>
                        <Col md={3}>
                          <strong>Nome:</strong>
                          <div>{NormalizarNome(client.Nome)}</div>
                        </Col>
                        <Col md={3}>
                          <strong>Telefone:</strong>
                          <div>{client.Telefone}</div>
                        </Col>

                        <Col md={3}>
                          <strong>Aniversario:</strong>
                          <div>{FormatDate(client.DataAniversario)}</div>
                        </Col>
                        <Col md={1}>
                          <strong>Saldo:</strong>
                          <div>{FormatCurrency(client.Saldo)}</div>
                        </Col>
                      </div>
                    ))}
                  </div>
                  <div className="d-flex justify-content-end">
                    <Pagination className="mt-3 text-end me-3">
                      {/* Botão "Primeiro" */}
                      <PaginationItem disabled={currentPage === 1}>
                        <PaginationLink onClick={() => handlePageChange(1)}>
                          Primeiro
                        </PaginationLink>
                      </PaginationItem>

                      {/* Botão "Anterior" */}
                      <PaginationItem disabled={currentPage === 1}>
                        <PaginationLink
                          previous
                          onClick={() =>
                            handlePageChange(Math.max(currentPage - 1, 1))
                          }
                        />
                      </PaginationItem>

                      {/* Páginas do bloco atual */}
                      {Array.from(
                        { length: endPage - startPage + 1 },
                        (_, index) => startPage + index
                      ).map((page) => (
                        <PaginationItem key={page} active={currentPage === page}>
                          <PaginationLink onClick={() => handlePageChange(page)}>
                            {page}
                          </PaginationLink>
                        </PaginationItem>
                      ))}

                      {/* Botão "Próximo" */}
                      <PaginationItem disabled={currentPage === totalPages}>
                        <PaginationLink
                          next
                          onClick={() =>
                            handlePageChange(Math.min(currentPage + 1, totalPages))
                          }
                        />
                      </PaginationItem>

                      {/* Botão "Último" */}
                      <PaginationItem disabled={currentPage === totalPages}>
                        <PaginationLink onClick={() => handlePageChange(totalPages)}>
                          Último
                        </PaginationLink>
                      </PaginationItem>
                    </Pagination>
                  </div>
                </div>
              ) : (
                <p className="h5 mt-4 p-2">Nenhum cliente encontrado.</p>
              )}
            </Col>
          </div>
        </div>

        {/* MODAL DE WEBHOOKS */}
        <Modal isOpen={modalOpen} toggle={() => setModalOpen(!modalOpen)} contentClassName="p-2">

          <ModalHeader toggle={() => setModalOpen(!modalOpen)}>Configurar Fila</ModalHeader>
          <ModalBody>
            <Form>
              <FormGroup>
                <Label for="nome">Nome</Label>
                <Input
                  id="nome"
                  value={webhookData.nome}
                  onChange={(e) => {setWebhookData({ ...webhookData, nome: e.target.value }); setNomeError('');}}
                invalid={!!nomeError}
                />
                <FormFeedback>{nomeError}</FormFeedback>
              </FormGroup>
              <FormGroup>
                <Label for="query">Query:</Label>
                <Input
                  type="textarea"
                  id="query"
                  readOnly
                  rows="10"
                  style={{
                    fontSize: '0.75rem',
                    fontFamily: 'monospace',
                    whiteSpace: 'pre-wrap',
                    overflowWrap: 'break-word'
                  }}
                  value={
                    webhookData.query
                      ?.replace(/^"|"$/g, '')
                      .replace(/\\n/g, '\n')
                      .replace(/\\t/g, '    ')
                      .replace(/\\u003c/g, '<')
                      .replace(/\\u003e/g, '>')
                  }
                  onChange={(e) =>{
                    setWebhookData({ ...webhookData, query: e.target.value });
                    setQueryError('');
                  }}
                  invalid={!!queryError}
                />
                <FormFeedback>{queryError}</FormFeedback>
              </FormGroup>

              <FormGroup>
                <Label for="tipoExecucao">Tipo de Execução</Label>
                <Input
                  id="tipoExecucao"
                  type="select"
                  value={webhookData.tipoExecucao}
                  onChange={(e) =>{ setWebhookData({ ...webhookData, tipoExecucao: e.target.value }); setTipoExecucaoError('');}}
                  invalid={!!tipoExecucaoError}
                >
                  <option value="manual">Manual</option>
                  <option value="automatico">Automático</option>
                  <option value="agendado">Agendado</option>
                </Input>
              </FormGroup>

              <FormGroup>
                <Label for="parametro">Parametro</Label>
                <Input
                  id="parametro"
                  value={webhookData.parametro}
                  onChange={(e) =>{ setWebhookData({ ...webhookData, parametro: e.target.value }); setParametroError('');}}
                  invalid={!!parametroError}
                />
                <FormFeedback>{parametroError}</FormFeedback>
              </FormGroup>

              <FormGroup>
                <Label for="fila">Fila</Label>
                <Input
                  id="fila"
                  type="text"
                  value={webhookData.fila}
                  required
                  onChange={(e) => {
                    setWebhookData({ ...webhookData, fila: e.target.value });
                    setFilaError('');
                  }}
                  onKeyDown={(e) => {
                    const key = e.key;
                    const isValidChar = /^[a-zA-Z0-9]$/.test(key);
                    if (!isValidChar && key !== 'Backspace' && key !== 'Delete' && key !== 'ArrowLeft' && key !== 'ArrowRight') {
                      e.preventDefault();
                    }
                  }}
                  onPaste={(e) => {
                    const paste = e.clipboardData.getData('text');
                    if (!/^[a-zA-Z0-9]*$/.test(paste)) {
                      e.preventDefault();
                    }
                  }}
                  invalid={!!filaError}
                />
                <FormFeedback>{filaError}</FormFeedback>
              </FormGroup>


              {webhookData.tipoExecucao === 'agendado' &&
                <FormGroup className="d-flex flex-column">
                  <Label for="dateRange">Data e hora</Label>
                  <DatePicker
                    className="d-flex rounded-3 p-1"
                    selected={webhookData.dataRange ? new Date(webhookData.dataRange) : null}
                    showTimeSelect
                    onChange={(date) => setWebhookData({ ...webhookData, dataRange: date ? date.toISOString() : '' })}
                    locale="pt-BR"
                    dateFormat="dd/MM/yyyy"
                    placeholderText="Selecione a data e hora"
                  />
                </FormGroup>}
            </Form>
          </ModalBody>
          <ModalFooter>
            <Button className="cohort_create_button" onClick={() => handleDelete()} disabled={deleting || !webhookSalvo}>Excluir</Button>
            <Button className='cohort_create_button' disabled={!webhookSalvo } onClick={handleReenviarWebhook}>
              Enviar para Fila
            </Button>
            <Button className='cohort_create_button' onClick={handleSaveWebhook} disabled={buttonLoading || webhookSalvo}>{buttonLoading ? <Spinner size="sm" /> : "Salvar"}</Button>
            <Button color="secondary" onClick={() => setModalOpen(false)}>Cancelar</Button>
          </ModalFooter>
          {(success || error) && (
            <ToasterAdviser
              type={success ? "success" : "error"}
              message={success || error}
              icon={success ? "success" : "error"}
            />
          )}
        </Modal>
      </>
    </MainContainer>

  );
};


